import { render, staticRenderFns } from "./bandlabel.vue?vue&type=template&id=7cf39286&scoped=true"
import script from "./bandlabel.vue?vue&type=script&lang=js"
export * from "./bandlabel.vue?vue&type=script&lang=js"
import style0 from "./bandlabel.vue?vue&type=style&index=0&id=7cf39286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf39286",
  null
  
)

export default component.exports